import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../Redux/hooks";
import { clearPermissions, fetchRoles } from "../Redux/Slices/permissionsSlice";

export const useSyncTabs = () => {
  const roleID = useAppSelector((state) => state?.roleAndPermission?.roleID) || 0;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  useEffect(() => {
    const accessToken = localStorage.getItem("access_token");
    const lastPath = localStorage.getItem("lastPath");
    const logoutStatus = localStorage.getItem("LOGOUT_STATUS")==="LOGOUT"||false;
    const isAuthenticated = localStorage.getItem("LOGIN_STATUS") === "LOGIN"||false;
    if (isAuthenticated) dispatch(fetchRoles());
    //Handle if already logged in and path mismatch
    if (accessToken && lastPath && window.location.pathname === "/") {
      navigate(lastPath, { replace: true });
    }

    if (logoutStatus) {
        // Logout detected in tab
        dispatch(clearPermissions());
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("LOGIN_STATUS");
        localStorage.removeItem("activeFilter");
        localStorage.removeItem("lastPath");
        localStorage.clear();
        navigate("/");
      }

    const handleStorage = (event: StorageEvent) => {
      // console.log("Storage changed:", event.key, event.oldValue, "→", event.newValue);

      if (event.key === "access_token") {
        if (event.newValue) {
          // User logged in from another tab
          (roleID === 0) && dispatch(fetchRoles())
          const last = localStorage.getItem("lastPath") || "/dashboard";
          navigate(last, { replace: true });
        } else {
          // User logged out from another tab
          navigate("/", { replace: true });
        }
      }

      if (event.key === "LOGIN_STATUS") {
        const token = localStorage.getItem("access_token");
        (roleID === 0) && dispatch(fetchRoles())
        if (token && event.newValue && window.location.pathname !== event.newValue) {
          navigate('/dashboard', { replace: true });
        } 
      } 

      if (event.key === "logout-event" && logoutStatus) {
        // Logout detected in another tab
        dispatch(clearPermissions());
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("LOGIN_STATUS");
        localStorage.removeItem("activeFilter");
        localStorage.removeItem("lastPath");
        localStorage.clear();
        navigate("/");
      }
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);
};
